import Carousel, { CarouselRef } from "react-bootstrap/Carousel";
import React, { useCallback, useEffect } from "react";
import { useRef, useState } from "react";
import { Direction } from "./types";
import SettingsCalendar from "../../modal/ConsultationModals/Content/IndividualWeekSettings/Calendar";
import Calendar from "./Calendar";
import "./carousel.scss";
import handleWeekChange from "./utils/handleWeekChange";
import useInputState from "../inputState/useInputState";
import { getCurrentWeek } from "./legacyUtils";

interface Props {
    isSettings?: boolean;
}

const ControlledCarousel = ({ isSettings = false }: Props) => {
    const { weekOffset, version } = useInputState();
    const ref = useRef<CarouselRef | null>(null);
    const [index, setIndex] = useState(0);
    const [movementDirection, setMovementDirection] = useState(Direction.NEXT);

    const getWeeksFromOffset = useCallback(() => {
        const currentWeek = getCurrentWeek() + weekOffset;

        return [currentWeek, currentWeek === 52 ? 1 : currentWeek + 1];
    }, [weekOffset, version]); // eslint-disable-line react-hooks/exhaustive-deps

    const [weeks, setWeeks] = useState(getWeeksFromOffset());

    useEffect(() => {
        setWeeks(getWeeksFromOffset());
    }, [getWeeksFromOffset]);

    const moveSlide = (direction: Direction) => {
        if (ref.current) {
            if (direction === Direction.PREV) {
                ref.current.prev();
            }

            if (direction === Direction.NEXT) {
                ref.current.next();
            }
        }
        setMovementDirection(direction);
    };

    const handleSlideStart = () => {
        if (index === 0) {
            setIndex(1);
            if (movementDirection === Direction.PREV)
                setWeeks((prevWeeks) => [
                    prevWeeks[0],
                    handleWeekChange(prevWeeks[1], Direction.PREV),
                ]);
        }
        if (index === 1) {
            setIndex(0);
            if (movementDirection === Direction.NEXT)
                setWeeks((prevWeeks) => [
                    handleWeekChange(prevWeeks[0], Direction.NEXT),
                    prevWeeks[1],
                ]);
        }
    };

    const handleSlideEnd = () => {
        if (index === 1) {
            if (movementDirection === Direction.PREV)
                setWeeks((prevWeeks) => [
                    handleWeekChange(prevWeeks[0], Direction.PREV),
                    prevWeeks[1],
                ]);
        }
        if (index === 0) {
            if (movementDirection === Direction.NEXT)
                setWeeks((prevWeeks) => [
                    prevWeeks[0],
                    handleWeekChange(prevWeeks[1], Direction.NEXT),
                ]);
        }
    };

    return (
        <Carousel
            ref={ref}
            style={{ width: "100%" }}
            controls={false}
            indicators={false}
            interval={null}
            onSlide={handleSlideStart}
            onSlid={handleSlideEnd}
        >
            {weeks.map((week, index) => (
                <Carousel.Item key={index}>
                    {isSettings ? (
                        <SettingsCalendar
                            week={week}
                            moveSlide={moveSlide}
                            setWeeks={setWeeks}
                        />
                    ) : (
                        <Calendar
                            moveSlide={moveSlide}
                            week={week}
                            setWeeks={setWeeks}
                        />
                    )}
                </Carousel.Item>
            ))}
        </Carousel>
    );
};

export default ControlledCarousel;
